import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgxFileDropEntry } from 'ngx-file-drop';
import { isVideoFile } from './util';

@Component({
  selector: 'app-local-file-selector',
  templateUrl: './local-file-selector.component.html',
  styleUrls: ['./local-file-selector.component.scss']
})
export class LocalFileSelectorComponent implements OnInit {
  @Input() type!: 'audio' | 'video';
  @Output() fileDropped = new EventEmitter<File>();
  files: NgxFileDropEntry[] = [];
  fileErrorMessage: string = '';
  fileSize: string = '';

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {}

  dropped(files: NgxFileDropEntry[]) {
    this.files = files;

    for (const droppedFile of files) {
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;

        fileEntry.file((file: File) => {
          if (this.type === 'audio' && !file.type.includes('audio/')) {
            this.fileErrorMessage = 'Only audio file is allowed.';
            this.files = [];
            return;
          }

          if (this.type === 'video' && ((file.type?.length  && !file.type.includes('video/')) || !isVideoFile(file?.name))) {
            this.fileErrorMessage = 'Only video file is allowed.';
            this.files = [];
            return;
          }

          this.fileErrorMessage = '';
          this.fileSize = this.getFormattedSize(file.size);
          this.fileDropped.emit(file);
        });
      } else {
        this.fileErrorMessage = 'You have selected an empty folder';
      }
    }

    this.runForceRenderOnce();
  }

  getFormattedSize(size: number): string {
    const sizeInMB = size / (1024 * 1024);

    if (sizeInMB > 1) {
      return `${sizeInMB.toFixed(1)} MB`;
    } else {
      const sizeInKB = size / 1024;
      return `${sizeInKB.toFixed(1)} KB`;
    }
  }

  clearDroppedFiles() {
    this.files = [];
  }

  runForceRenderOnce() {
    setTimeout(() => {
      this.cdr.detectChanges();
    }, 1000);
  }
}
